var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22672 6.07422C2.0819 6.35103 2 6.66596 2 7.00002V17C2 18.1046 2.89543 19 4 19H20C21.1046 19 22 18.1046 22 17V7.00002C22 6.66596 21.9181 6.35103 21.7733 6.07422L13.577 11.8116C12.6301 12.4744 11.3699 12.4744 10.423 11.8116L2.22672 6.07422Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5731 5.08333C20.3916 5.02912 20.1992 5 20 5H4C3.80082 5 3.60844 5.02912 3.42688 5.08333L11.2832 10.5827C11.7136 10.884 12.2864 10.884 12.7168 10.5827L20.5731 5.08333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.f5157a0753028c9729b42ade119bb5d3.svg";
export { ForwardRef as ReactComponent };